import { MOCK_REPLY_INTERACTION_ID } from './mock-scenarios.const';

// Shape mirrors libs/chat/src/interfaces/ApiPromptResponse; types are not
// imported here because libs/shared/core sits below the chat lib.

export const mockChatReply: Readonly<unknown> = {
  reply:
    '**Het hitteprotocol bij Partou** is ontworpen om kinderen en medewerkers te beschermen tegen de gevolgen van hoge temperaturen. Hier zijn de belangrijkste punten:\n\n### Wanneer treedt het hitteprotocol in werking?\n- Bij een verwachte binnen- of buitentemperatuur van **25 graden Celsius of hoger** werken we volgens het algemene hitteprotocol en locatie-specifiek gezondheidsbeleid [^0][^1].\n\n### Belangrijke maatregelen\nKoeling, ventilatie en aangepaste activiteiten dragen bij aan een veilige omgeving.\n\n---\n[^0]: Temperatuur en Ventilatie\n[^1]: Hitteprotocol',
  interactionId: MOCK_REPLY_INTERACTION_ID,
  summary: 'Mock hitteprotocol summary.',
  referencedDocs: [
    {
      refId: 0,
      documentId: '5mPDbJzjqekJlvU2mS7ZkI',
      title: 'Temperatuur en Ventilatie',
      publishedDate: '2026-03-05T10:51:19+00:00',
    },
    {
      refId: 1,
      documentId: '3M06fllfJKpkbXWXw4wzQQ',
      title: 'Hitteprotocol',
      publishedDate: '2026-03-05T15:33:21+00:00',
    },
  ],
};

export const mockChatReplyFollowUp: Readonly<unknown> = {
  reply:
    '**Ook voor de babygroepen** geldt het hitteprotocol, met een paar aanvullende aandachtspunten:\n\n### Aanvullingen voor babygroepen\n- Babykamers worden eerder gekoeld en buitenslaap wordt opgeschort bij hoge temperaturen [^0].\n- Voorzie extra drink- en voedingsmomenten met aangepaste hoeveelheden.\n- Stem af met ouders via het reguliere oudercontact.',
  interactionId: 'a1b2c3d4-5678-4abc-9def-0123456789ab',
  summary: 'Mock hitteprotocol vervolgvraag samenvatting.',
  referencedDocs: [
    {
      refId: 0,
      documentId: '5mPDbJzjqekJlvU2mS7ZkI',
      title: 'Temperatuur en Ventilatie',
      publishedDate: '2026-03-05T10:51:19+00:00',
    },
  ],
};

export const mockCitationlessReply: Readonly<unknown> = {
  reply:
    '**Een algemeen antwoord** zonder verwijzingen naar specifieke bronnen. Dit gebeurt soms bij vragen die geen onderbouwing uit de kennisbank vereisen.\n\n- Geen voetnoten in dit antwoord.\n- Geen bronnen om te raadplegen.',
  interactionId: 'c3d4e5f6-7890-4abc-def0-123456789abc',
  summary: 'Mock antwoord zonder bronnen.',
  referencedDocs: [],
};

export const mockUnresolvedReply: Readonly<unknown> = {
  reply: 'Sorry, ik kan deze vraag op dit moment niet beantwoorden.',
  interactionId: 'b2c4f8a1-0d3e-4f5a-9c1b-2d3e4f5a6b7c',
  summary: '',
  referencedDocs: [],
  escalation: {
    escalationReason: 'uncertain',
    owner: 'hr',
  },
};
